import request from '@/utils/request';
import { stringify } from 'qs';
// 新增商品组
export async function save(payload) {
  return request(`/iwms-wms/wms/articlegroupconfig`, {
    method: 'POST',
    body: payload,
  });
}
export async function query(payload) {
  if (payload.articleCodeName) {
    return request(`/iwms-wms/wms/articlegroupconfig/getArticleByGroupName?articleCodeName=${payload.articleCodeName}&dcUuid=${payload.dcUuid}&groupName=${payload.groupName}`);
  } else {
    return request(`/iwms-wms/wms/articlegroupconfig/getArticleByGroupName?dcUuid=${payload.dcUuid}&groupName=${payload.groupName}`);
  }
}

export async function page(payload) {
  return request(`/iwms-wms/wms/articlegroupconfig/page`, {
    method: 'POST',
    body: payload
  });
}

export async function queryArticleGroupConfigs(payload) {
  return request(`/iwms-wms/wms/articlegroupconfig/get?dcUuid=${payload.dcUuid}`);
}

// 根据dcuuid和商品代码/名称查询商品组
export async function getByDcUuidAndArticleCodeName(payload) {
  return request(`/iwms-wms/wms/articlegroupconfig/getByDcUuidAndArticleCodeName?dcUuid=${payload.dcUuid}&articleCodeName=${payload.articleCodeName}`);
}

// 删除商品组
export async function remove(payload) {
  return request(`/iwms-wms/wms/articlegroupconfig/delete?dcUuid=${payload.dcUuid}&groupName=${payload.groupName}`, {
    method: 'DELETE'
  });
}

// 编辑商品组
export async function modifyArticle(payload) {
  return request(`/iwms-wms/wms/articlegroupconfig/modify?dcUuid=${payload.dcUuid}&groupName=${payload.groupName}&newName=${payload.newName}&virtualityBin=${payload.virtualityBin}`, {
    method: 'POST'
  });
}

// 批量删除商品
export async function batchRemove(payload) {
  return request(`/iwms-wms/wms/articlegroupconfig/deleteArticles?dcUuid=${payload.dcUuid}&groupName=${payload.groupName}`, {
    method: 'DELETE',
    body: payload.articleUuids,
  });
}

// 批量新增
export async function batchAdd(payload) {
  return request(`/iwms-wms/wms/articlegroupconfig/addArticles?dcUuid=${payload.dcUuid}&groupName=${payload.groupName}`, {
    method: 'POST',
    body: payload.articles,
  });
}

// 为商品组添加所有商品
export async function addArticle(payload) {
  return request(`/iwms-wms/wms/articlegroupconfig/addAllArticles?companyUuid=${payload.companyUuid}&dcUuid=${payload.dcUuid}&groupName=${payload.groupName}`, {
    method: 'POST'
  });
}

// 删除商品组内所有商品
export async function removeArticle(payload) {
  return request(`/iwms-wms/wms/articlegroupconfig/deleteAllArticles?dcUuid=${payload.dcUuid}&groupName=${payload.groupName}`, {
    method: 'DELETE'
  });
}

export async function getArticleGroupConfig(payload) {
  return request(`/iwms-wms/wms/articlegroupconfig/getArticleGroupConfig?dcUuid=${payload.dcUuid}&articleUuid=${payload.articleUuid}`);
}

export async function adjustOrder(payload) {
  return request(`/iwms-wms/wms/articlegroupconfig/adjustorder?dcUuid=${payload.dcUuid}&articleUuid=${payload.articleUuid}&groupName=${payload.groupName}&orderNo=${payload.orderNo}`, {
    method: 'POST'
  });
}
